import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subscription } from 'rxjs';

import { LicensesEnum } from '../../../../api/monitoring/licenses.enum';
import { SubscriptionLicenses } from '../../models/monitoring.configs.model';
import { AccountManagementService } from '../../services/account-management.service';
import { FormControl, Validators } from '@angular/forms';
import { QuotaPreferenceService } from '@Admin/AccountManagement/services/quota-preference.service';
import { MonitoringQuotaTypesEnum } from '@api/mentions/enum/monitoring-quota-types.enum';

@Component({
    selector: 'agpr-social-preferences',
    templateUrl: './social-preferences.component.html',
    styleUrls: ['./social-preferences.component.scss'],
    providers: [QuotaPreferenceService],
    standalone: false
})
export class SocialPreferencesComponent implements OnInit, OnDestroy {

    @Input()
    set shouldShowQuotaBanner(flag: boolean) {
        this.quotaPreferenceService.setShouldShowQuotaBanner(flag);
    }

    @Output() networksError = new EventEmitter<boolean>();

    licenses: SubscriptionLicenses;
    isReadOnly = false;
    networksControl = new FormControl([], Validators.required);

    private subscriptions: Subscription[] = [];

    readonly licensesEnum = LicensesEnum;
    readonly monitoringQuotaTypes = MonitoringQuotaTypesEnum;

    constructor(
        private accountManagementService: AccountManagementService,
        private quotaPreferenceService: QuotaPreferenceService
    ) { }

    ngOnInit() {
        this.subscriptions.push(
            this.accountManagementService.getSocialLicenses().subscribe(licenses => {
                this.licenses = licenses;
                this.updateNetworksControl();
            }),
            this.accountManagementService.getReadOnly().subscribe(isReadOnly => {
                this.isReadOnly = isReadOnly;
            })
        );
    }
    onLicenseChange() {
        this.updateNetworksControl();
    }

    private updateNetworksControl() {
        if (!this.licenses) {
            return;
        }
        const selected = Object.values(this.licenses).filter(value => value === true);
        this.networksControl.setValue(selected);
        this.emitNetworksError();
    }
    get networks() {
        return this.networksControl;
    }
    private emitNetworksError() {
        const hasError = !!this.networks.errors?.['required'];
        this.networksError.emit(hasError);
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
